$('body').on('click', '.js-show-attendees-search', function(event) {
    showPopUp('attendees-search');
    calcPopupPosition();
});

$('body').on('click', '.js-send-feedback', function(event) {
    event.preventDefault();

    $(this).addClass('btn-preloader');

    sendFeedback($(this).parents('form'));
});

window.onresize = calcPopupPosition;

function showLastFeedbackSlide() {
    $('.js-send-feedback').addClass('slider-arrow slider-arrow-next js-finish-feedback').removeClass('js-send-feedback');
    $('.js-finish-feedback').trigger('click');
}

function deleteFeedbackOpportunity() {
    $('.test-end__feedback').remove();
}

function calcPopupPosition() {
    var windowHeight = window.innerHeight,
        popupHeight = $('.attendees-search-pop-up').innerHeight(),
        popupTopPosition = (windowHeight - popupHeight) / 2;

    $('.attendees-search__inner-container').addClass('attendees-search__inner-container_absolute').css('top', popupTopPosition)
}

$('.feedback-answer__radio').change(function () {
    $(this).parents('.feedback-question-block__answers-wrap')
        .next('.feedback-question-block__btn-wrap')
        .find('.js-next-feedback-question')
        .removeClass('btn-disabled')
        .attr('disabled', false);
});


$('body').on('input', '.feedback-answer__textarea', function () {
    var textareaValue = $.trim($(this).val());

    if (textareaValue.length > 0) {
        $(this).parents('.feedback-question-block__answers-wrap')
            .next('.feedback-question-block__btn-wrap')
            .find('.js-next-feedback-question')
            .removeClass('btn-disabled')
            .attr('disabled', false);
    }
    else {
        $(this).parents('.feedback-question-block__answers-wrap')
            .next('.feedback-question-block__btn-wrap')
            .find('.js-next-feedback-question')
            .addClass('btn-disabled')
            .attr('disabled', true);
    }
});
